export default __webpack_public_path__ + "static/media/iconeMensagemMaior.d00a47f9.png";